import React, { useEffect, useState } from 'react'
import './signature-profiles.css'
import {
  ListBoxTemplatePure,
  DialogTemplatePure,
  HeaderHLPure,
  ButtonAddHLPure,
  GridSelectionHLPure,
  ButtonHLPure,
  DialogYesNoHLPure,
  DialogSystemGLPure,
  SearchBarHLPure,
  LabelModalPure
} from '../../pures'
import { useMediaQuery } from '@material-ui/core'
import { filterBy, orderBy } from '@progress/kendo-data-query'
import { PromotionalFooterPure } from '../../pures'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import {
  SignatureProfileService,
  UserSignatureProfileService,
  UserService,
} from '../../../services'
import { Grid } from '@material-ui/core'
import { ArrowBtnMobile } from '../../../assets/logos/icons'

const HeaderColumns = (props) => {
  const { t, title } = props
  return (
    <span
      className={
        title === t('signatureProfilesView.grid.profile')
          ? 'grid-header-one'
          : 'grid-headers'
      }
    >
      {title}
    </span>
  )
}

const CellColumnName = (props) => {
  const { dataItem } = props
  return (
    <td>
      <div className='grid-cell-double-container-margin-left'>
        <p className='grid-cell-titles'>{dataItem.name}</p>
      </div>
    </td>
  )
}

const CellColumnUser = (props) => {
  const { dataItem } = props
  return (
    <td>
      <div>
        <p className='grid-cell-subtitles'>{`${dataItem.user.firstName} ${dataItem.user.firstLastName}`}</p>
      </div>
    </td>
  )
}

const CellColumnBtns = (props) => {
  const { handleChangePage, t, dataItem } = props
  return (
    <td>
      <div className='grid-btn-div'>
        <button className='grid-btn-action' onClick={() => handleChangePage(t('signatureProfilesView.grid.seeDetails'), dataItem)}>
          <p>{t('assembliesPrincipalView.grid.btns.detail')}</p>
        </button>
      </div>
      <div className='grid-btn-arrow' onClick={() => handleChangePage(t('signatureProfilesView.grid.seeDetails'), dataItem)}>
        <img alt='assemblies-arrow' src={ArrowBtnMobile} />
      </div >
    </td >
  )
}


export default function SignatureProfilesView(props) {
  const { profiles, token, getProfiles } = props
  const { t } = useTranslation()

  const url = process.env.REACT_APP_MIFIRMA_API
  const signatureProfileService = new SignatureProfileService(url)
  const userSignatureProfileService = new UserSignatureProfileService(url)
  const userService = new UserService(url)

  const is1360 = useMediaQuery('(max-width:1360px)')
  const is1100 = useMediaQuery('(max-width:1100px)')
  const is960 = useMediaQuery('(max-width:960px)')
  const is820 = useMediaQuery('(max-width:820px)')

  const sort = [
    {
      field: 'name',
      dir: 'asc',
    },
  ]

  const initialFilter = {
    logic: 'and',
    filters: [
      {
        field: 'name',
        operator: 'contains',
        value: '',
      },
    ],
  }

  const history = useHistory()
  const showRegistered = useMediaQuery('(min-width:720px)')
  const showActions = useMediaQuery('(min-width:560px)')

  const [dataItem, setDataItem] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [success, setSuccess] = useState(false)
  const [error, setError] = useState(false)
  const [textError, setTextError] = useState('')

  const [searchValue, setSearchValue] = useState('')
  const [fiter, setFilter] = useState(initialFilter)
  const [dataGrid, setDataGrid] = useState(profiles)

  const [showDialogDelete, setShowDialogDelete] = useState(false)
  const [showDialogAssignment, setShowDialogAssignment] = useState(false)
  const toggleDialogAssignment = () =>
    setShowDialogAssignment(!showDialogAssignment)
  const toggleDialogDelete = () => {
    setShowDialogDelete(!showDialogDelete)
  }

  const [notAssignedUsersOriginal, setNotAssignedUsersOriginal] = useState([])
  const [assignedUsersOriginal, setAssignedUsersOriginal] = useState([])
  const [notAssignedUsers, setNotAssignedUsers] = useState([])
  const [assignedUsers, setAssignedUsers] = useState([])
  const [notAssignedUsersNew, setNotAssignedUsersNew] = useState([])
  const [assignedUsersNew, setAssignedUsersNew] = useState([])
  const [userProfileInEdit, setUserProfileInEdit] = useState(undefined)

  const deleteSigatureProfiles = async () => {
    setShowDialogDelete(false)
    setIsLoading(true)
    try {
      let result = await signatureProfileService.deleteSigatureProfiles(
        token,
        dataItem.id
      )
      let profileDeleteStatus = Number(result.statusCode)
      if (profileDeleteStatus !== 200) {
        switch (profileDeleteStatus) {
          case -2:
            setTextError(
              t('signatureProfilesView.errors.profile.not.found')
            )
            throw new Error()
          case -3:
            setTextError(
              t('signatureProfilesView.errors.profile.assigned.many.users')
            )
            throw new Error()
          default:
            setTextError(
              t('signatureProfilesView.errors.general.delete.profile')
            )
            throw new Error()
        }
      } else {
        setSuccess(true)
        setTimeout(() => {
          setSuccess(false)
          getProfiles()
        }, 4000)
      }
    } catch (e) {
      setError(true)
      setTimeout(() => {
        setError(false)
      }, 4000)
    } finally {
      setIsLoading(false)
      setNameComponentUser('')
    }
  }

  const MyCustomItem = (props) => {
    let { dataItem, selected, ...others } = props
    return (
      <li {...others}>
        <span> {props.dataItem.name} </span>
      </li>
    )
  }

  //Copy the dataItem
  const cloneUser = (user) => {
    return Object.assign({}, user)
  }

  //Get users profiles
  const getUserProfile = async (dataItem) => {
    setIsLoading(true)
    setUserProfileInEdit(cloneUser(dataItem))
    try {
      //Get information from listOne
      let userNotAssigned = await userService.getUsersCollaboratorInvite(token)
      // let userNotAssignedStatus = Number(userNotAssigned.statusCode)

      //Get information from listTwo
      let userAssigned = await userSignatureProfileService.getUsersProfiles(
        token,
        dataItem.id
      )
      let userAssignedStatus = Number(userAssigned.statusCode)
      let userNotAssignedListTwo = []

      if (userAssignedStatus === 200) {
        //Get complete name to every user from listOne
        userNotAssigned.usersCollaborator =
          userNotAssigned.usersCollaborator.map((user) => {
            let name =
              user.firstName +
              ' ' +
              user.firstLastName +
              ' ' +
              user.secondLastName
            user.name = name
            user.selected = false
            return user
          })

        //Delete users that not have complete name in array
        userNotAssignedListTwo = userNotAssigned.usersCollaborator.filter(
          (item) => item.name !== '  '
        )

        //Get complete name to every user from listTwo
        userAssigned.data.map((userInfo) => {
          let name =
            userInfo.userInformation.firstName +
            ' ' +
            userInfo.userInformation.firstLastName +
            ' ' +
            userInfo.userInformation.secondLastName
          userInfo.name = name
          userInfo.selected = false
          return userInfo
        })
        setNotAssignedUsersOriginal(userNotAssigned.usersCollaborator)
        setAssignedUsersOriginal(userAssigned.data)

        // setIsLoading(false)
        let verifiedAvaibleList = [] // Tabla izquierda
        let verifiedAssignedList = [] // Tabla derecha

        // 7.- Llenar lista para tabla derecha (verifiedAssignedList)
        for (let i = 0; i < userAssigned.data.length; i++) {
          verifiedAssignedList.push({
            userId: userAssigned.data[i].userId,
            signatureProfileId: userAssigned.data[i].signatureProfileId,
            selected: userAssigned.data[i].selected,
            name: userAssigned.data[i].name,
          })
        }

        // 8.- Se filtran los valores no repetidos obtenidos de userNotAssigned
        let userNotAssignedFiltered = userNotAssignedListTwo.filter((obj1) => {
          return !userAssigned.data.some((obj2) => {
            return obj1.id === obj2.userId
          })
        })
        // 9.- Llenar lista para tabla izquierda (verifiedAvaibleList)
        verifiedAvaibleList = userNotAssignedFiltered.map((item) => {
          let result = {
            userId: item.id,
            signatureProfileId: dataItem.id,
            selected: item.selected,
            name: item.name,
          }
          return result
        })

        // 10.- Se almacenan los valores en el state
        setNotAssignedUsers(verifiedAvaibleList)
        setAssignedUsers(verifiedAssignedList)
        setIsLoading(false)
      } else {
        setNotAssignedUsers(userNotAssignedListTwo)
        setAssignedUsers(userAssigned.data)
        setIsLoading(false)
      }

      setIsLoading(false)
      setShowDialogAssignment(!showDialogAssignment)
    } catch (error) {
      console.log(error)
      setTextError(t('signatureProfilesView.errors.general.get.profiles'))
      setIsLoading(false)
      setError(true)
      setTimeout(() => {
        setError(false)
      }, 4000)
      return false
    }
  }

  //Actualizar listas
  const listResult = (listOne, listTwo) => {
    setNotAssignedUsersNew(listOne)
    setAssignedUsersNew(listTwo)
  }

  const onSubmitUser = async (e) => {
    e.preventDefault()
    let backendStatusCode = 0
    setIsLoading(true)

    // Filtrar perfiles por agregar al usuario
    let assignedUsersProfilesFiltered = assignedUsersNew.filter((obj1) => {
      return !assignedUsersOriginal.some((obj2) => {
        return obj1.userId === obj2.userId
      })
    })

    // Filtrar perfiles por eliminar del usuario
    let deletedUsersProfilesFiltered = notAssignedUsersNew.filter((obj1) => {
      return assignedUsersOriginal.some((obj2) => {
        return obj1.userId === obj2.userId
      })
    })

    try {
      if (
        assignedUsersProfilesFiltered.length <= 0 &&
        deletedUsersProfilesFiltered.length <= 0
      )
        return false

      // Agregar perfil de firma a usurio
      if (assignedUsersProfilesFiltered.length > 0) {
        let usersProfilesToAssign = []
        for (let i = 0; i < assignedUsersProfilesFiltered.length; i++) {
          usersProfilesToAssign.push({
            userId: assignedUsersProfilesFiltered[i].userId,
            signatureProfileId:
              assignedUsersProfilesFiltered[i].signatureProfileId,
          })
        }
        let usersProfilesAssigned =
          await userSignatureProfileService.createProfilesUser(
            usersProfilesToAssign,
            token
          )
        if (usersProfilesAssigned.statusCode != 200) {
          backendStatusCode = usersProfilesAssigned.statusCode
          throw new Error()
        }
      }
      // Eliminar perfil de firma de usuario
      if (deletedUsersProfilesFiltered.length > 0) {
        let usersProfilesToDelete = []
        for (let i = 0; i < deletedUsersProfilesFiltered.length; i++) {
          usersProfilesToDelete.push({
            userId: deletedUsersProfilesFiltered[i].userId,
            signatureProfileId:
              deletedUsersProfilesFiltered[i].signatureProfileId,
          })
        }

        const arrayToDelete = `${JSON.stringify(usersProfilesToDelete)}`
        let usersProfilesDeleted =
          await userSignatureProfileService.deleteUserProfiles(
            arrayToDelete,
            token
          )
        if (usersProfilesDeleted.statusCode != 200) {
          backendStatusCode = usersProfilesDeleted.statusCode
          throw new Error()
        }
      }
      setShowDialogAssignment(!showDialogAssignment)
      setSuccess(true)
      setTimeout(() => {
        setSuccess(false)
      }, 4000)
      return true
    } catch (error) {
      setTextError(t('signatureProfilesView.errors.general.add.profile'))
      setError(true)
      setTimeout(() => {
        setError(false)
      }, 4000)
      return false
    } finally {
      setNameComponentUser('')
      setIsLoading(false)
    }
  }

  const [nameComponentUser, setNameComponentUser] = useState('')

  useEffect(() => {
    if (!dataItem || !dataItem.id || nameComponentUser === '') return

    switch (nameComponentUser) {
      case t('signatureProfilesView.grid.seeDetails'):
        history.push(`/signature-profile-details/${dataItem.id}`)
        break
      case 'Asignar usuarios':
        getUserProfile(dataItem)
        break
      default:
        break
    }
  }, [dataItem, nameComponentUser])

  useEffect(() => {
    setDataGrid(profiles)
  }, [profiles])

  useEffect(() => {
    setFilter({
      logic: 'and',
      filters: [{ field: 'name', operator: 'contains', value: searchValue }],
    })
  }, [searchValue])

  let AllHeadersColumns = (props) => <HeaderColumns {...props} t={t} />
  let CellColumnOne = (props) => <CellColumnName {...props} t={t} />
  let CellColumnTwo = (props) => <CellColumnUser {...props} t={t} />
  let CellColumnFour = (props) => <CellColumnBtns {...props} t={t} handleChangePage={handleChangePage} />

  let widthCellOne = '120px'
  let widthCellTwo = '120px'
  let widthCellFour = '30px'

  if (is1360) {
    widthCellFour = '40px'
  }

  if (is1100) {
    widthCellFour = '50px'
  }

  if (is960) {
    widthCellFour = '60px'
  }

  if (is820) {
    widthCellFour = '70px'
  }

  const handleChangePage = (view, profile) => {
    setDataItem(profile)
    setNameComponentUser(view)
  }

  return (
    <div className='standard-wrapper'>
      <div className='signatureProfileView-header'>
        <HeaderHLPure title={t('signatureProfilesView.titleUserProfile')} />
      </div>
      <div className='signatureProfileView-body'>
        <div className='signatureProfileView-navbar'>
          <div className='signatureProfileView-btn-add'>
            <ButtonAddHLPure
              nameBtn={t('signatureProfilesView.btnAddUserProfile')}
              onClickBtn={() => history.push('/signature-profile-details')}
              iconAdd
            />
          </div>
          <SearchBarHLPure
            placeholder={t('signatureProfilesView.searchPlaceholder')}
            searchValue={searchValue}
            onSearchChange={(e) => {
              setSearchValue(e.target.value)
            }}
          />
        </div>
        <div className='signatureProfileView-grid'>
          <GridSelectionHLPure
            skip={0}
            take={6}
            dataGrid={filterBy(orderBy(dataGrid, sort), fiter)}

            columnOne
            titleRow1={t('signatureProfilesView.grid.profile')}
            cellColumnOne={CellColumnOne}
            headerColumnOne={AllHeadersColumns}
            widthColumnOne={widthCellOne}
            minResizableWidth1={'auto'}

            columnTwo={true}
            titleRow2={t('signatureProfilesView.grid.registeredBy')}
            cellColumnTwo={CellColumnTwo}
            headerColumnTwo={AllHeadersColumns}
            widthColumnTwo={widthCellTwo}
            minResizableWidth2={widthCellTwo}


            columnFour
            titleRow4={t('signatureProfilesView.grid.actions')}
            cellColumnFour={CellColumnFour}
            headerColumnFour={AllHeadersColumns}
            widthColumnFour={widthCellFour}
            minResizableWidth4={widthCellFour}
          />
        </div>
        <div className='signatureProfilesDetailsView-btns'>
          <ButtonHLPure
            nameBtn={t('signatureProfilesDetailsView.back')}
            onClickBtn={() => history.push('/configuration')}
          />
        </div>
      </div>
      <div className='signatureProfileView-footer'>
        <PromotionalFooterPure />
      </div>
      {showDialogDelete && (
        <DialogYesNoHLPure
          titleDialog={t('ModalDelete.title')}
          loadingComponent={isLoading}
          textBtnCancel={t('ModalDelete.cancel')}
          cancel={() => {
            setNameComponentUser('')
            toggleDialogDelete()
          }}
          saveBtn={t('ModalDelete.delete')}
          handleSubmit={deleteSigatureProfiles}
        >
          <LabelModalPure label={`${t('signatureProfilesDetailsView.modal.delete.question')} ${dataItem.name}?`} />

        </DialogYesNoHLPure>
      )}
      {showDialogAssignment && (
        <DialogTemplatePure
          canelBtn={t('ModalAssignment.btnCancel')}
          saveBtn={t('ModalAssignment.btnSubmit')}
          title={t('ModalAssignment.assignTitle')}
          description={t('ModalAssignment.description')}
          cancel={() => {
            setNameComponentUser('')
            toggleDialogAssignment()
          }}
          textError={textError}
          handleSubmitProfile={(e) => onSubmitUser(e)}
          dataItem={userProfileInEdit}
        >
          <ListBoxTemplatePure
            titleListOne={t('signatureProfilesView.avaibleProfiles')}
            titleListTwo={t('signatureProfilesView.assignedProfiles')}
            listDataOne={notAssignedUsers}
            listDataTwo={assignedUsers}
            loadingComponent={isLoading}
            textField='name'
            item={MyCustomItem}
            listResult={listResult}
          />
        </DialogTemplatePure>
      )}
      <DialogSystemGLPure
        showLoadingRequesting={isLoading}
        toggleLoadingRequesting={() => setIsLoading((prev) => !prev)}
        showCompletedRequesting={success}
        toggleCompletedRequesting={() => setSuccess((prev) => !prev)}
        showErrorRequesting={error}
        toggleErrorRequesting={() => setError((prev) => !prev)}
        messageError={textError}
      />
    </div>
  )
}
